import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), React.createElement("path", {
    d: "M16.636 2.637l-1.272-1.274L9 7.727 2.636 1.363 1.364 2.637 7.727 9l-6.363 6.363 1.272 1.274L9 10.273l6.364 6.364 1.272-1.274L10.273 9z"
  }));
};

export default SvgComponent;